import {useAppContext} from 'contexts';
import React from 'react';
import styled from 'styled-components';

export const ContactDetails = ({show}: {show: boolean}) => {
    const {userProfile} = useAppContext();
    if (!show) return null;

    return (
        <Container>
            <strong>
                Please feel free to contact us if you have any queries.
            </strong>

            <ul>
                <li>
                    <strong>Email : </strong>
                    <a href={`mailto:${userProfile?.manufacturerEmail}`}>
                        {userProfile?.manufacturerEmail}
                    </a>
                </li>
                <li>
                    <strong>Phone : </strong>
                    <a href={`tel:${userProfile?.manufacturerPhone}`}>
                        {userProfile?.manufacturerPhone}
                    </a>
                </li>
            </ul>
        </Container>
    );
};

const Container = styled.div`
    margin-top: 15px;
    font-size: 0.85em;
    color: #6d6e77;
    width: 100% !important;

    strong {
        font-weight: normal;
    }
`;
